/**
 * An AbortSignal that follows the caller's signal (React Query's, aborted when
 * the last observer leaves) and also aborts after `timeoutMs` (#2191 D11).
 * Call `done()` once the response is read so the timer never outlives it.
 * Built by hand rather than with `AbortSignal.any`/`AbortSignal.timeout`,
 * which Safari supports only from 17.4.
 */
export function boundedSignal(
  parent: AbortSignal | undefined,
  timeoutMs: number,
): { signal: AbortSignal; done: () => void } {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (parent?.aborted) {
    controller.abort();
    return { signal: controller.signal, done: () => {} };
  }
  parent?.addEventListener("abort", abort, { once: true });
  const timer = setTimeout(abort, timeoutMs);
  return {
    signal: controller.signal,
    done: () => {
      clearTimeout(timer);
      parent?.removeEventListener("abort", abort);
    },
  };
}
